//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Order() {

    //get locale
    const { t } = useTranslation();

    return (
        <div className="col-span-12">
            <h2 className="text-2xl font-semibold mb-4">{t('my_orders')}</h2>
            <table className="min-w-full table-auto border-collapse bg-white rounded-lg shadow-md overflow-hidden">
                <thead>
                <tr className="bg-gray-100 text-left">
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('transaction_id')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('date')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('amount')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('status')}</th>
                </tr>
                </thead>
                <tbody>
                    <tr className="border-b">
                        <td className="px-6 py-3 text-sm text-gray-800">1</td>
                        <td className="px-6 py-3 text-sm text-gray-800">2</td>
                        <td className="px-6 py-3 text-sm text-gray-800">3</td>
                        <td className={`px-6 py-3 text-sm`}>
                            123
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}